import { useGetAccidentIncidentPendingSignOffsQuery } from "../../../services/api/formsApi";

interface Props {
  currentPage: number;
}

export function useHandleAccidentIncidentPendingSignOffs({
  currentPage,
}: Props) {
  const { data, isLoading } = useGetAccidentIncidentPendingSignOffsQuery({
    page: currentPage,
  });

  return { data, isLoading };
}
